import { render, staticRenderFns } from "./RegistrationPopup.vue?vue&type=template&id=9a7c311e&"
import script from "./RegistrationPopup.vue?vue&type=script&lang=js&"
export * from "./RegistrationPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports